export const togglebutton = {
  colorScheme: {
    light: {
      root: {
        hoverColor: '{neutral.700}',
        hoverBackground: '{primary.300}',
      },
      background: '#ededed',
      color: '#333333',
      icon: {
        color: '#333333',
        hoverColor: '{neutral.700}',
      },
      checked: {
        background: '#ededed',
      },
    },
    dark: {
      root: {
        hoverColor: '{neutral.100}',
        hoverBackground: '{primary.500}',
      },
      background: '#3C434F',
      color: '#ffffff',
      icon: {
        color: '#ffffff',
        hoverColor: '{neutral.100}',
      },
      checked: {
        background: '{surface.500}',
      },
    },
  },
};
